import * as React from 'react';
import { ArticleHeading2, ModalWindow, ArticleParagraph1, ArticleParagraph3 } from '@cian/ui-kit';

import { Author } from './inner/Author';
import { BankItem } from './inner/BankItem';
import { BanksList } from './inner/BanksList';
import { JKList } from './inner/JKList';
import * as styles from './PromoDescriptionModal.css';
import { IAvailableJk, IPromo } from '../../types/newbuilding/promos';

interface IPromoDescriptionModalProps {
  contactsButton?: React.ReactNode;
  onClose(): void;
  onJkClick(jk: IAvailableJk, index: number): void;
  onMortgageClick(): void;
  open: boolean;
  promo: IPromo;
}

export const PromoDescriptionModal = ({
  contactsButton,
  promo,
  open,
  onClose,
  onJkClick,
  onMortgageClick,
}: IPromoDescriptionModalProps) => {
  const { availableJks, authorLogoUrl, authorName, bank, banks, description, features, isFromBuilder, name } = promo;
  const authorLabel = isFromBuilder ? 'Застройщик' : 'Агент';

  return (
    <ModalWindow open={open} fixed={false} width="100%" maxWidth={640} onClose={onClose} escape outside>
      <div className={styles['content']} data-testid="PromoDescriptionModal">
        <div className={styles['title']}>
          <ArticleHeading2 as="h2">{name}</ArticleHeading2>
        </div>
        {!!features.length && (
          <div className={styles['labels-container']}>
            {features.map(({ name, value }, idx) => (
              <div key={idx} className={styles['label']}>
                <ArticleParagraph3 color="gray60_100">{name}</ArticleParagraph3>
                <ArticleParagraph1>{value}</ArticleParagraph1>
              </div>
            ))}
          </div>
        )}
        {description && (
          <div className={styles['description']}>
            <ArticleParagraph1 whiteSpace="pre-line">{description}</ArticleParagraph1>
          </div>
        )}
        {!!availableJks.length && (
          <div className={styles['available-jks']}>
            <JKList jkList={availableJks} onJkClick={onJkClick} />
          </div>
        )}
        {!!banks.length && (
          <div className={styles['banks']}>
            <BanksList banks={banks} onMortgageClick={onMortgageClick} />
          </div>
        )}
        {bank && (
          <div className={styles['banks']}>
            <BankItem bank={bank} label="Банк" onMortgageClick={onMortgageClick} />
          </div>
        )}
        {authorName && (
          <Author label={authorLabel} name={authorName} logoUrl={authorLogoUrl} contactsButton={contactsButton} />
        )}
      </div>
    </ModalWindow>
  );
};

PromoDescriptionModal.displayName = 'PromoDescriptionModal';
